import { AreaFilterOptionInformation, FilterKey } from '@studyportals/search-filters';
import { FilterOptionsBase } from './FilterOptionsBase';
import { AreaPresenter } from '@/presenters/AreaPresenter';

export class AreaOptions extends FilterOptionsBase {
	public override createOptions(): AreaFilterOptionInformation[] {
		return AreaPresenter.allOptions();
	}

	public override getFilterKey(): FilterKey {
		return FilterKey.AREA;
	}
}
